


























import {defineComponent, onMounted, PropType, ref, watch} from "@vue/composition-api"
import {useMutations, useState} from "vuex-composition-helpers";
import {IPortalTimelineItem} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";

export default defineComponent({
    name: "PortalTimelineItemComponent",
    props: {
        index: {type: Number},
        item: {type: Object as PropType<IPortalTimelineItem>}
    },
    setup: (props) => {
        const {selectedItemIndex} = useState(['selectedItemIndex'])
        const {setSelectedItem, setSelectedItemIndex, unsetOpenTopics} = useMutations(['setSelectedItem', 'setSelectedItemIndex', 'unsetOpenTopics'])

        const isActive = ref(false)

        onMounted(() => {
            isActive.value = selectedItemIndex.value == props.index

            if (localStorage.selectedItemIndex) {
                setSelectedItemIndex(localStorage.selectedItemIndex)
                isActive.value = localStorage.selectedItemIndex == props.index
            }

            watch(selectedItemIndex, (value) => {
                localStorage.selectedItemIndex = value
                isActive.value = value == props.index

                setSelectedItemIndex(value)
                setSelectedItem(value)
                unsetOpenTopics()
            })
        })

        return {
            isActive,
            selectedItemIndex,
            setSelectedItemIndex
        }
    }
})
